"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Link_1 = __importDefault(require("@mui/material/Link"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var makeLinkStyling_1 = __importDefault(require("./makeLinkStyling"));
var Link = function (_a) {
    var children = _a.children, onClick = _a.onClick, variant = _a.variant;
    var muiComponents = {
        button: 'button',
        footer: 'a',
        text: 'a',
    };
    return ((0, jsx_runtime_1.jsx)(Link_1.default, { css: (0, makeLinkStyling_1.default)({ variant: variant }), component: muiComponents[variant], onClick: onClick, underline: "hover", children: children }));
};
Link.defaultProps = defaultProps_1.default;
exports.default = Link;
//# sourceMappingURL=Link.js.map